import { EMPTY_VALUE } from '@cs-cms/types';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { CpsGridCell } from './CpsGridCell';

export const BooleanCell: React.FC<GridCustomCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field];
  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title=""
    >
      {typeof value === 'boolean' ? value.toString() : EMPTY_VALUE}
    </CpsGridCell>
  );
};
